(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["hero"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('hp-home-hero-carousel')) {
  customElements.define('hp-home-hero-carousel', class extends HTMLElement {
    connectedCallback() {
      if (this.abort) return;

      this.abort = new AbortController();
      const options = { signal: this.abort.signal };

      this.slides = [...this.querySelectorAll('[data-hp-slide]')];
      this.pages = [...this.querySelectorAll('[data-hp-page]')];
      this.pauseButton = this.querySelector('[data-hp-pause]');
      this.image = this.slides[1]?.querySelector('img');
      this.current = 0;
      this.paused = false;
      this.transitioning = false;
      this.inView = false;
      this.phaseTimers = new Set();
      this.nextChange = performance.now() + 6000;
      this.motion = window.matchMedia('(prefers-reduced-motion: reduce)');
      this.ready = this.image?.complete && this.image.naturalWidth > 0;

      this.slides.forEach(slide => slide.classList.remove('is-text-hidden'));
      this.switchTo(0);

      this.image?.addEventListener('load', () => {
        this.ready = true;
        this.nextChange = performance.now() + 6000;
        this.schedule();
      }, options);

      this.pages.forEach((button, index) => {
        button.addEventListener('click', () => this.show(index), options);
      });

      this.pauseButton.addEventListener('click', () => {
        this.paused = !this.paused;
        this.pauseButton.setAttribute('aria-pressed', String(this.paused));
        this.pauseButton.textContent = this.paused
          ? this.pauseButton.dataset.playLabel
          : this.pauseButton.dataset.pauseLabel;
        this.nextChange = performance.now() + 6000;
        this.schedule();
      }, options);

      this.addEventListener('focusin', () => this.schedule(), options);

      this.addEventListener('focusout', () => queueMicrotask(() => {
        this.nextChange = performance.now() + 6000;
        this.schedule();
      }), options);

      document.addEventListener('visibilitychange', () => {
        this.nextChange = performance.now() + 6000;
        this.schedule();
      }, options);

      this.motion.addEventListener('change', () => this.schedule(), options);

      this.observer = new IntersectionObserver((entries) => {
        this.inView = entries[0].isIntersecting;
        this.nextChange = performance.now() + 6000;
        this.schedule();
      }, { threshold: 0.1 });

      this.observer.observe(this);
    }

    wait(milliseconds) {
      return new Promise(resolve => {
        const timer = setTimeout(() => {
          this.phaseTimers.delete(timer);
          resolve();
        }, milliseconds);

        this.phaseTimers.add(timer);
      });
    }

    switchTo(index) {
      this.current = index;

      this.slides.forEach((slide, number) => {
        const active = number === index;

        slide.classList.toggle('is-active', active);
        slide.setAttribute('aria-hidden', String(!active));
        slide.inert = !active;

        slide.querySelectorAll('video').forEach(video => {
          if (active) video.play().catch(() => {});
          else video.pause();
        });
      });

      this.pages.forEach((button, number) => {
        if (number === index) button.setAttribute('aria-current', 'true');
        else button.removeAttribute('aria-current');
      });
    }

    async show(index) {
      if (this.transitioning || index === this.current || (index === 1 && !this.ready)) return;

      clearTimeout(this.timer);
      this.nextChange = performance.now() + 6000;

      if (this.motion.matches) {
        this.switchTo(index);
        this.schedule();
        return;
      }

      this.transitioning = true;

      const outgoing = this.slides[this.current];
      const incoming = this.slides[index];

      outgoing.classList.add('is-text-hidden');
      incoming.classList.add('is-text-hidden');

      await this.wait(250);
      if (!this.isConnected) return;

      this.switchTo(index);

      await this.wait(180);
      if (!this.isConnected) return;

      incoming.classList.remove('is-text-hidden');

      await this.wait(250);
      if (!this.isConnected) return;

      outgoing.classList.remove('is-text-hidden');
      this.nextChange = performance.now() + 6000;
      this.transitioning = false;
      this.schedule();
    }

    schedule() {
      clearTimeout(this.timer);

      if (!this.isConnected || !this.ready || this.paused || this.transitioning || !this.inView
        || document.hidden || this.motion.matches || this.contains(document.activeElement)) return;

      this.timer = setTimeout(() => {
        this.show(this.current === 0 ? 1 : 0);
      }, Math.max(0, this.nextChange - performance.now()));
    }

    disconnectedCallback() {
      clearTimeout(this.timer);
      this.phaseTimers?.forEach(timer => clearTimeout(timer));
      this.phaseTimers?.clear();
      this.observer?.disconnect();
      this.abort?.abort();
      this.abort = null;
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
